/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Property type.
 * Represents the physical category or use of a property.
 */
export enum PropertyType {
    HOUSE = 'HOUSE',
    APARTMENT = 'APARTMENT',
    OFFICE = 'OFFICE',
    RETAIL = 'RETAIL',
    WAREHOUSE = 'WAREHOUSE',
    LAND = 'LAND',
    PARCEL = 'PARCEL',
    PARKING = 'PARKING',
    INDUSTRIAL = 'INDUSTRIAL',
    OTHER = 'OTHER',
}
